import React, { useState } from "react";
import styles from "./RegulatoryCompliance.module.scss";
import OSHASVG from "./OSHASVG";
import BioTerrorismSVG from "./BioTerrorismSVG";
import GlobalSVG from "./GlobalSVG";
import RealTimeSVG from "./RealTimeSVG";
import DocArrowSVG from "./DocArrowSVG";
import { ContactCard } from "../FAQSection/FAQSection";
import ContactUsFormModal from "../ContactUsFormModal/ContactUsFormModal";

const complianceData = [
  {
    id: 1,
    text: "OSHA, Kosher, Halal, and FDA-aligned compliance",
    icon: OSHASVG,
  },
  {
    id: 4,
    text: "Bioterrorism Act statements & facility registrations",
    icon: BioTerrorismSVG,
  },
  { id: 2, text: "US operations enabling global compliance", icon: GlobalSVG },
  {
    id: 3,
    text: "Real-time traceability with batch-level documentation",
    icon: RealTimeSVG,
  },
];

const documents = [
  "Certificate of Analysis (CoA)",
  "Safety Data Sheets (SDS)",
  "Technical Data Sheets (TDS)",
  "Kosher and Halal Certifications",
  "Country of Origin Declarations",
  "Ingredient Specifications",
];

const ComplianceCard = ({ compliance, index }) => {
  return (
    <div
      className={styles.complianceCard}
      style={
        index % 2 === 1
          ? {
              backgroundColor: "rgba(250, 250, 250, 1)",
            }
          : {}
      }
    >
      {/* Concentric SVG */}
      <div className={styles.icon}>{compliance.icon()}</div>
      {/* Text */}
      <div className={styles.text}>{compliance.text}</div>
    </div>
  );
};

export const ComplianceCardsRow = ({ complianceData }) => {
  return (
    <div className={styles.complianceCards}>
      {complianceData.map((compliance, idx) => (
        <ComplianceCard
          key={compliance.id}
          compliance={compliance}
          index={idx}
        />
      ))}
    </div>
  );
};

function RegulatoryCompliance() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  return (
    <div className={styles.regulatoryCompliance}>
      {/* Small Heading */}
      <h6>REGULATORY COMPLIANCE</h6>
      {/* Big Heading */}
      <h2>Compliance You Can Rely On</h2>
      {/* Description */}
      <p>
        We provide clear and complete documentation with every shipment to
        ensure your operations stay fully compliant. Our internal checks and
        supplier partnerships help you meet regulatory expectations with
        confidence.
      </p>
      {/* Row of Compliance Cards */}
      <ComplianceCardsRow complianceData={complianceData} />
      {/* Documents and Support */}
      <div className={styles.documentsAndSupport}>
        {/* Heading and documents list */}
        <div className={styles.headingAndDocumentsList}>
          <div className={styles.heading}>Documents we provide on request</div>
          {documents.map((document, idx) => (
            <div key={idx} className={styles.document}>
              <DocArrowSVG />
              <div className={styles.documentText}>{document}</div>
            </div>
          ))}
        </div>
        {/* Contact card */}
        <ContactCard
          showImages={false}
          title="Need something not listed?"
          description="Contact us for product-specific documentation"
          onOpen={() => setIsContactModalOpen(true)}
          additionalStyles={{
            // width: "300px",
            backgroundColor: "rgba(250, 250, 250, 1)",
          }}
        />
        {/* Contact Us Modal */}
        <ContactUsFormModal
          open={isContactModalOpen}
          onClose={() => setIsContactModalOpen(false)}
        />
      </div>
    </div>
  );
}

export default RegulatoryCompliance;
